import React, { useCallback } from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';
import { getPopupContent } from './utils';
import { usePopupContext } from '../contexts/PopupContext';

const GatedMeasureNoticePopup = () => {
    const {
        params: { name, onContinueClick },
        actions: { hideGatedMeasureNoticePopup },
    } = usePopupContext();

    const { header, message, cancelButtonText, continueButtonText } = getPopupContent(name);
    const onContinue = useCallback(
        event => {
            hideGatedMeasureNoticePopup();
            onContinueClick(event);
        },
        [hideGatedMeasureNoticePopup, onContinueClick],
    );

    return (
        <Popup
            cssClass="gated-measure-popup"
            header={header}
            message={message}
            buttons={[
                <Button key="cancel-button" onClick={hideGatedMeasureNoticePopup}>
                    {cancelButtonText}
                </Button>,
                <Button key="continue-button" onClick={onContinue}>
                    {continueButtonText}
                </Button>,
            ]}
        />
    );
};

export default GatedMeasureNoticePopup;
